const contactTypePerson = "Person";
const contactTypeOther = "Other";

export { contactTypePerson, contactTypeOther };
